"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { LifeBuoy } from "lucide-react"
import SideBar from "../SideBare/index"
import Navbar from "../Navbar/index"
import { StatusModalCheck  } from "../../components"
import { useCurrentUser } from "../../utils/context/UserProvider";
import { useAccessChecker } from "../../utils/Functions/Authorization"
const MainLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false)
    const [isHovered, setIsHovered] = useState(false)
    const { currentUser } = useCurrentUser()
    const { checkAccess } = useAccessChecker()


    const handleAlertDismiss = () => {
        
        console.log("Alert dismissed")
    }

    return (
        <div className="flex h-screen overflow-y-auto">
            <SideBar collapsed={collapsed} setCollapsed={setCollapsed} />
            <div
                className={`flex-1 overflow-x-hidden bg-white dark:bg-neutral-950 transition-all duration-300 flex flex-col`}
            >
                <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
                <main className={`flex-1 max-w-full mt-16  ${!collapsed ? "lg:pl-60" : "lg:pl-[5.5rem]"}`}>
                    {currentUser && currentUser.status && (
                        <StatusModalCheck status={currentUser.status} onDismiss={handleAlertDismiss} contactUrl="/support" />
                    )}
                    {children}

                </main>


                {
                    currentUser?.role?.name === 'Client' &&
                    <div className="fixed bottom-6 right-6 z-50">
                        <div className="relative group">
                            {/* Tooltip */}
                            <div
                                className={`absolute bottom-full right-0 mb-3 px-4 py-2 bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 text-sm font-medium rounded-xl shadow-lg transition-all duration-300 whitespace-nowrap ${isHovered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"}`}
                            >
                                Need help? Contact support
                                <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 dark:border-t-gray-100"></div>
                            </div>

                            {/* Main Button - Using Link from react-router-dom */}
                            {
                                checkAccess('tickets', 'read') &&
                                <Link
                                    to="/tickets"
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    className="relative z-50 flex items-center justify-center w-14 h-14 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-yellow-300 dark:focus:ring-yellow-800 group"
                                    aria-label="Contact Support"
                                >
                                    {/* Animated Background Ring */}
                                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 opacity-75 animate-pulse"></div>

                                    {/* Icon Container */}
                                    <div className="relative z-10 transition-transform duration-300 group-hover:rotate-12">
                                        <LifeBuoy className="w-6 h-6" />
                                    </div>

                                    {/* Notification Dot */}
                                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white dark:border-gray-900 flex items-center justify-center">
                                        <div className="w-2 h-2 bg-white rounded-full animate-ping"></div>
                                    </div>
                                </Link>

                            }

                            {/* Ripple Effect */}
                            <div className="absolute inset-0 z-30 rounded-full bg-yellow-500 opacity-20 scale-0 group-hover:scale-150 transition-transform duration-500"></div>
                        </div>
                    </div>
                }

            </div>
        </div>
    )
}

export default MainLayout
